//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepState } from './Enums';

export class RepertoireInputItem extends ItemBase {
    Composer: string | null = null;
    Description: string | null = null;
    Difficulty: string | null = null;
    Duration: number | null = null;
    Genre: string | null = null;
    Instrument: string | null = null;
    Language: string | null = null;
    Notes: string | null = null;
    Source: string | null = null;
    Title: string | null = null;
    TeacherID: string | null = null;
    Status: RepState = RepState.Active;

    constructor(initializer?: Partial<RepertoireInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RepertoireInputItem";
}
